import { calcWidgetCurve } from '../../util/appUtils';

export const CLOUD_ANALYTICS_REPORTS = Object.freeze({
  top_queries: { path: '/system/analytics/search/popular', query: { type: 'search' } },
  zero_results: { path: '/system/analytics/search/queriesWithoutResults', query: { type: 'all' } },
  lost_opportunities: { path: '/system/analytics/search/lostOpportunities', query: {} },
});

export const PLUGIN_ANALYTICS_ACTIONS = Object.freeze({
  top_queries: 'analytics.top_queries',
  zero_results: 'analytics.zero_results',
  lost_opportunities: 'analytics.lost_opportunities',
  products_popular_from_search: 'analytics.products_popular_from_search',
});

function normalizeCurve(curve, reportType) {
  if (!Array.isArray(curve) || curve.length === 0) return { data: [] };
  const calculated = calcWidgetCurve(curve);
  return {
    data: Object.keys(calculated).map((key) => {
      const row = calculated[key];
      if (reportType === 'top_queries') {
        return {
          total: row.total ?? 0,
          click: row.click ?? 0,
          ctr: Number(((row.ctr ?? 0) * 100).toFixed(2)),
          label: row.label,
        };
      }
      if (reportType === 'zero_results') return { pv: row.total ?? 0, label: row.label };
      return { total: row.total ?? 0, label: row.label };
    }),
  };
}

export function normalizeAnalyticsReport(data, reportType) {
  const source = data || {};
  return {
    data: (source.records || []).map(raw => ({
      query: raw.query,
      searches: raw.searches ?? raw.users ?? raw.total ?? 0,
      click: raw.click ?? 0,
      noaction: raw.noaction ?? 0,
      ctr: raw.ctr ?? 0,
    })),
    users: source.users || { total: 0, filteredTotal: 0, otherTotal: 0 },
    queries: source.queries || { total: 0, filteredTotal: 0, otherTotal: 0, ctr: 0 },
    curve: normalizeCurve(source.curve || [], reportType),
  };
}
